import Tournaments from './container'

export default Tournaments
